import RaceCardInfoField from './RaceCardInfoField';

export default RaceCardInfoField;
